export default __webpack_public_path__ + "static/media/c001-general2024-2.1f8df841.png";